<template>
  <div class="billingItem">
    <div class="billing-sum row flex-center">
      <div class="billing-sum-item">
        <div class="sum-value">
          ¥ <span class="num">{{ accountInformation.totalAmount }}</span>
        </div>
        <div>消费金额</div>
      </div>
      <div class="billing-sum-item">
        <div
          class="sum-value"
          :class="getClassForOverdue(accountInformation.overdueAmount)"
        >
          ¥ <span class="num">{{ accountInformation.overdueAmount }}</span>
        </div>
        <div>欠费总额</div>
      </div>
    </div>
    <div
      class="billing-card"
      v-for="(row, index) in combinedBills"
      :key="index"
    >
      <div class="toptitle row flex-center">
        <!-- <i class="iconfont icon-sanjiao"></i> -->
        <div class="flex-1">{{ row.billTypeName }}</div>
        <div class="typeTag" :class="statusColor(row)">
          {{ row.statusName }}
        </div>
      </div>
      <div class="info">
        <div class="billing-sum row flex-center">
          <div class="billing-sum-item three left">
            <div class="sum-value">
              ¥ <span class="num">{{ row.planAmount }}</span>
            </div>
            <div>应收金额</div>
          </div>
          <div class="billing-sum-item three center">
            <div class="sum-value">
              ¥ <span class="num">{{ row.actualAmount || "0.00" }}</span>
            </div>
            <div>已收金额</div>
          </div>
          <div class="billing-sum-item three right">
            <div
              class="sum-value"
              :class="getClassForOverdue(row.overdueAmount)"
            >
              ¥ <span class="num">{{ row.overdueAmount || "0.00" }}</span>
            </div>
            <div>欠费总额</div>
          </div>
        </div>
        <!--
                        billType 2卡券交易 3 账户 
                    -->
        <div
          class="infoitem row flex-center"
          v-if="row.billType == 2 || row.billType == 3"
        >
          <div class="left">收费时间：</div>
          <div class="flex-1 righttext">{{ row.firstChargeTime }}</div>
        </div>

        <template v-if="row.billType == 1">
          <div class="infoitem row flex-center">
            <div class="left">首次收费时间：</div>
            <div class="flex-1 righttext">{{ row.firstChargeTime }}</div>
          </div>

          <div class="infoitem row flex-center">
            <div class="left">就诊时间：</div>
            <div class="flex-1 righttext">{{ row.appointTime }}</div>
          </div>
        </template>

        <div class="clinic">
          {{ row.clinicName }}
          <span v-if="row.orderDoctorNames">/ {{ row.orderDoctorNames }}</span>
          <span v-if="row.consultantNames">/ {{ row.consultantNames }}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import func from "@/util/func.js";
import moment from "moment";
import { userStore } from "@/store/user.js";
import {
  patientCostView,
  billPendingList,
  billProcessedList,
  billdocList,
} from "@/api/patient.js";
import { loadingStore } from "@/store/loading.js";

export default {
  name: "billingInfo",
  props: [],
  components: {},
  data: function () {
    return {
      accountInformation: {}, //账户信息
      billsTop: [], //未处理账单
      billsBot: [], //下面的表单
      checkList: [
        {
          label: "2",
          name: "已结清",
          value: true,
        },
        {
          label: "3",
          name: "已收费",
          value: true,
        },
        {
          label: "4",
          name: "已退费",
          value: true,
        },
        {
          label: "5",
          name: "已撤单",
          value: false,
        },
        {
          label: "6",
          name: "已作废",
          value: false,
        },
      ],
      expands: [],
    };
  },
  computed: {
    combinedBills() {
      const combinedArray = [...this.billsTop, ...this.billsBot];
      return combinedArray.sort((a, b) => {
        const timeA = moment(a.firstChargeTime).format("x");
        const timeB = moment(b.firstChargeTime).format("x");
        return Number(timeA) - Number(timeB);
      });
    },
  },
  setup() {
    let loading = loadingStore();
    return {
      loading,
    };
  },

  mounted: function () {
    let that = this;
    const aloginStoreuth = userStore();
    const cusId = aloginStoreuth.cusId;
    const corpId = aloginStoreuth.corpId;
    that.GetExpenseOverview(cusId, corpId);
    that.getUnprocessedBills(cusId, corpId);
    that.getProcessedBills();
  },
  methods: {
    GetExpenseOverview(cusId, corpId) {
      //获取消费概览
      let that = this;
      patientCostView({
        cusId,
        corpId,
      }).then((res) => {
        that.accountInformation = res.data.data;
      });
    },
    getUnprocessedBills(cusId, corpId) {
      let that = this;
      //获取未处理账单
      billPendingList({
        cusId,
        corpId,
      }).then((res) => {
        that.billsTop = res.data.data;
      });
    },
    getCheckLists() {
      let concatenatedLabels = "";

      // Iterate through the checkList array
      this.checkList.forEach((item) => {
        if (item.value) {
          if (concatenatedLabels !== "") {
            concatenatedLabels += ", "; // Add a comma and space before appending the next label
          }
          concatenatedLabels += item.label; // Append the label to the string
        }
      });
      return concatenatedLabels;
    },
    getProcessedBills() {
      //获取已处理账单
      let that = this;
      const aloginStoreuth = userStore();

      const cusId = aloginStoreuth.cusId;
      const corpId = aloginStoreuth.corpId;

      const status = this.getCheckLists();
      let subdata = {
        cusId,
        corpId,
        status,
      };

      that.loading.showLoading();

      billProcessedList(subdata).then((res) => {
        that.loading.hideLoading();
        let data = res.data.data.map((item) => {
          item.childTable = [];
          item.hasChildren = true;
          item.childrenloader = false;
          item.childKey = 0;

          //需要先判断 item.firstChargeTime

          item.firstChargeTime = that.formatDateTime(item.firstChargeTime);

          return item;
        });
        that.billsBot = data;
      });
    },
    statusColor(status) {
      //1-治疗中 2-待缴费 3-已完成 4-已退费 5已作废
      switch (Number(status)) {
        case 1:
          return "todo"; // Replace with your desired color class
        case 2:
          return "todo"; // Replace with your desired color class
        case 3:
          return "success"; // Replace with your desired color class
        case 4:
          return "gary"; // Replace with your desired color class
        default:
          return "gary"; // Replace with a default color class or logic
      }
    },
    getClassForStatus(status) {
      if (status == 5) {
        return "red";
      } else {
        return "";
      }
    },
    getClassForOverdue(price) {
      if (price === 0 || func.isEmpty(price)) {
        return "";
      } else {
        return "red";
      }
    },
    formatDateTime(dateTime) {
      if (dateTime) {
        if (!(dateTime instanceof Date)) {
          return moment(dateTime).format("YYYY-MM-DD HH:mm");
        }
      }
      return "";
    },
  },
};
</script>

<style lang="scss" scoped>
.billingItem {
  .billing-sum {
    background-color: #fff;
    border-radius: 0.083rem;
    margin: 0 0 0.25rem;
    padding: 0.25rem 0;

    &-item {
      width: 50%;
      text-align: center;
      font-size: 0.25rem;
      color: #666;
      line-height: 0.375rem;

      &.three {
        width: 33.3%;
      }

      &.left {
        text-align: left;
      }

      &.center {
        text-align: center;
      }

      &.right {
        text-align: right;
      }

      .sum-value {
        margin-bottom: 0.104rem;

        &.red {
          color: #ff4d4f;

          .num {
            color: #ff4d4f;
          }
        }
      }

      .num {
        font-size: 0.354rem;
        color: #333;
        line-height: 20px;
      }
    }
  }

  .billing-card {
    background-color: #fff;
    border: 1px solid #e6e6e6;
    border-radius: 0.083rem;
    margin: 0 0 0.25rem;
    text-align: left;

    .billing-sum {
      margin: 0;
    }

    .toptitle {
      font-size: 0.292rem;
      padding: 0.167rem 0.313rem;
      border-bottom: 1px solid #ededed;
      background: #f7f7f7;

      .icon-sanjiao {
        color: #999999;
        margin-right: 0.104rem;
      }

      .typeTag {
        font-size: 0.25rem;
        padding: 0.083rem 0.125rem;
        border-radius: 0.042rem;

        &.red {
          background: #ffdbdc;
          color: #ff4d4f;
        }

        &.green {
          background: #dcf3d1;
          color: #52c41a;
        }

        &.yellow {
          background: rgb(252, 250, 238);
          color: #faad14;
        }
      }
    }

    .info {
      padding: 0.25rem;

      .infoitem {
        font-size: 0.292rem;
        margin-top: 0.25rem;

        .left {
          width: 2.083rem;
          color: #666;
        }

        .righttext {
          font-size: 0.292rem;
          color: #333;
        }
      }

      .clinic {
        font-size: 0.292rem;
        margin-top: 0.25rem;
        color: #666;
      }
    }

    &.done {
      .infoitem .left {
        width: 2.1rem;
      }
    }
  }
}
</style>
